import React, { Component } from 'react'

import config from '../../../../../../config'

import './style.scss'

const MODULE_NAME = config.modules.linkages.key

export default class Ribbon extends Component {
    render() {
        return <div className={`workspace-${MODULE_NAME}`}>{'Linkages ribbon'}</div>
    }
}
